import angular from 'angular';
import svgInjector from 'svg-injector';

export default angular.module('icon', [])
.directive('icon', icon);

function icon() {
	var directive = {
		link: link,
		restrict: 'E',
		template: '<img class="icon-svg" ref="image" alt="" />',
		scope: {}
	};
	return directive;

	function link(scope, element, attrs) {
		if (!attrs.hasOwnProperty('src')) {
			return null;
		}

		var src = attrs.src;
		var img = element[0].querySelector('.icon-svg');
		// Set the image src attribute
		img.setAttribute('src', wp.template_directory_uri + src);
		// Call the SVG injector
		svgInjector(element[0].querySelector('.icon-svg'), null, () => {
			// Remove all the "fill" attribute
			const filledElements = element[0].querySelectorAll('[fill]');
			if (filledElements) {
				for (let i = 0; i < filledElements.length; i++) {
					if (filledElements[i].getAttribute('fill') !== 'none' && filledElements[i].getAttribute('fill') !== 'currentColor') {
						filledElements[i].removeAttribute('fill');
					}
				}
			}
		});
	}
}



/** WEBPACK FOOTER **
 ** ./src/js/icon/icon.js
 **/